function initAnnouncementBarCarousel(slideshow) {
  if (slideshow.dataset.carouselPatched === 'true' || typeof slideshow.setSlidePosition !== 'function') return;
  slideshow.dataset.carouselPatched = 'true';

  const originalSetSlidePosition = slideshow.setSlidePosition.bind(slideshow);

  slideshow.setSlidePosition = (position) => {
    const step = slideshow.sliderItemOffset || slideshow.slider.clientWidth;
    const isLoopingJump = Math.abs(position - slideshow.slider.scrollLeft) > step * 1.5;

    if (!isLoopingJump) {
      originalSetSlidePosition(position);
      return;
    }

    slideshow.slider.style.scrollBehavior = 'auto';
    originalSetSlidePosition(position);
    setTimeout(() => {
      slideshow.slider.style.scrollBehavior = '';
    }, 50);
  };
}

function initAllAnnouncementBarCarousels() {
  document.querySelectorAll('slideshow-component.announcement-bar--slide').forEach(initAnnouncementBarCarousel);
}

if (window.customElements.get('slideshow-component')) {
  initAllAnnouncementBarCarousels();
} else {
  window.customElements.whenDefined('slideshow-component').then(initAllAnnouncementBarCarousels);
}

document.addEventListener('shopify:section:load', initAllAnnouncementBarCarousels);
